<script>
  import { onMount } from "svelte";
  import p5 from "p5";

  let container;
  let sketch;

  onMount(() => {
    sketch = new p5((p) => {
      let waveAmplitude = 250;
      let numBands;
      let loopDuration = 30;
      let loopSpeed = 12 / (loopDuration * 0.9);
      let startTime = 0;
      let timeOffsets = [];

      // Create the canvas and set up initial values
      p.setup = () => {
        p.createCanvas(p.windowWidth, p.windowHeight);
        p.colorMode(p.HSB, 360, 100, 100, 100);
        numBands = Math.floor(p.width / 80 * 3.14); // Recalculate the number of bands based on canvas width
        timeOffsets = Array.from({ length: numBands + 1 }, () => p.random(0, 444));
      };

      // Draw each frame with optimized performance
      p.draw = () => {
        // Reduce background redraw if possible
        p.background(22); // Keep background color but limit full redraw

        let bandWidth = 26; // Use strong scaling for better visibility

        // Precompute time once for all bands
        let elapsedTime = (p.millis() - startTime) * 0.001;
        for (let i = 0; i <= numBands; i++) {
          let timeFactor = (elapsedTime + timeOffsets[i]) * loopSpeed;
          let hue = (i * 40 + timeFactor * 10) % 360;
          p.fill(hue, 255, 155);
          p.noStroke();
          p.beginShape();

          // Left edge noise (adjusted for performance)
          for (let y = 0; y <= p.height; y++) {
            let noiseFactorLeft = (p.noise(y * 0.0044636457, timeFactor + i) - 0.55) * 2;
            let xOffsetLeft = noiseFactorLeft * waveAmplitude;
            p.vertex(i * bandWidth + xOffsetLeft, y);
          }

          // Right edge noise (adjusted for performance)
          for (let y = p.height; y >= 0; y--) {
            let noiseFactorRight = (p.noise(y * 0.008, timeFactor + i) - 0.15) * 2;
            let xOffsetRight = noiseFactorRight * waveAmplitude;
            p.vertex((i + 1) * bandWidth + xOffsetRight, y);
          }

          p.endShape(p.CLOSE);
        }

        // Ensure the last band fully covers the right edge
        p.fill((numBands * 40) % 360, 100, 100);
        p.rect(numBands * bandWidth - bandWidth * 0.1, 0, p.width, p.height);
      };

    }, container);

    return () => {
      sketch.remove();
    };
  });
</script>

<div bind:this={container} class="p5-container"></div>

<style>
  .p5-container {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: -1;
    background: black;
  }
</style>
